import { render, staticRenderFns } from "./PriceDiscountBadge.vue?vue&type=template&id=4bd2ae9f&scoped=true"
import script from "./PriceDiscountBadge.vue?vue&type=script&lang=js"
export * from "./PriceDiscountBadge.vue?vue&type=script&lang=js"
import style0 from "./PriceDiscountBadge.vue?vue&type=style&index=0&id=4bd2ae9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd2ae9f",
  null
  
)

export default component.exports